import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IPois } from "../../varibles/interface";
import { initialState, NAME_SLICE } from "./constants";

const locationSlice = createSlice({
    name: NAME_SLICE,
    initialState,
    reducers: {
        getLocationsRequest: (state) => {
            state.loadingLocations = true;
        },
        getLocationsSuccess: (state, action: PayloadAction<IPois[]>) => {
            state.locations = action.payload;
            state.locationsLoadedAt = Date.now();
            state.loadingLocations = false;
        },
        getLocationsFailure: (state) => {
            state.loadingLocations = false;
        },
        getAllLocationsRequest: (state) => {
            state.loadingAllLocations = true;
        },
        getAllLocationsSuccess: (state, action: PayloadAction<IPois[]>) => {
            state.allLocations = action.payload;
            state.allLocationsLoadedAt = Date.now();
            state.loadingAllLocations = false;
        },
        getAllLocationsFailure: (state) => {
            state.loadingAllLocations = false;
        },
        getPois: (state) => {
            state.loading = true;
        },
        getPoisSuccess: (state, action: PayloadAction<IPois[]>) => {
            state.loading = false;
            state.data = action.payload;
        },
        getPoisFailure: (state) => {
            state.loading = false;
        },
        add: (state, action) => {
            const location = action.payload;
            const { data } = state;
            state.data = [...data, location];
        },
        update: (state, action) => {
            const location = action.payload;
            const { data } = state;
            state.data = data.map(item => item.id === location.id ? location : item)
        },
        delete: (state, action) => {
            const id = action.payload;
            const { data } = state;
            state.data = data.filter(item => item.id !== id);
        },
    },
})

export const locationActions = locationSlice.actions

const locationReducer = locationSlice.reducer;

export default locationReducer;
